import { useEffect, useId, useState } from 'react';
import { Drawer } from '@mui/material';

import SigninButtonPopup from './SigninButtonPopup';
import './PreviewSigninDrawer.css';

const SIGNIN_COPY = {
    report: {
        title: 'Report a problem',
        subtitle: 'Sign in to report incorrect information or harmful content.',
    },
    follow: {
        title: 'Sign in to follow',
        subtitle: 'Hear more from your favorite speakers and podcasts.',
    },
    notForMe: {
        title: 'Personalize what you hear',
        subtitle: 'Sign in to save your listening preferences.',
    },
    preferences: {
        title: 'More or less',
        subtitle: 'Sign in to choose what you hear more or less of.',
    },
};

export default function PreviewSigninDrawer({ open, action, onClose, onSignedIn, onTransitionExited }) {
    const headingId = useId();
    const [busy, setBusy] = useState(false);
    // Keep the purpose visible through the closing transition after the caller
    // clears its pending action.
    const [lastAction, setLastAction] = useState(action || 'preferences');
    useEffect(() => {
        if (action) setLastAction(action);
        if (!open) setBusy(false);
    }, [action, open]);
    const copy = SIGNIN_COPY[action || lastAction] || SIGNIN_COPY.preferences;
    const close = () => {
        if (!busy) onClose();
    };

    return (
        <Drawer
            anchor='bottom'
            open={open}
            onClose={close}
            ModalProps={{ keepMounted: false, disableEscapeKeyDown: busy, onTransitionExited }}
            PaperProps={{
                role: 'dialog',
                'aria-modal': true,
                'aria-labelledby': headingId,
                sx: { borderRadius: '20px 20px 0 0', maxHeight: 'calc(var(--app-drawer-height, 100vh) * 0.9)' },
            }}
        >
            <div className='previewSigninDrawer appDrawerSurface'>
                <SigninButtonPopup
                    {...copy}
                    presentation='sheet'
                    headingId={headingId}
                    close={close}
                    onSignedIn={onSignedIn}
                    onBusyChange={setBusy}
                    autoFocusPhone
                />
            </div>
        </Drawer>
    );
}
